import { FUNNEL_ATTRIBUTES_WHITELIST } from '~/services/funnelAttributes/config';
import QueryParams from '~/services/QueryParams';

import { FunnelAttributes } from './types';

class FunnelAttributesService {
  private captured = false;
  private attributes: FunnelAttributes = {};

  captureFromUrl(): void {
    if (this.captured) return;
    this.captured = true;

    FUNNEL_ATTRIBUTES_WHITELIST.forEach(({ queryParam, mapValue }) => {
      const raw = QueryParams.getQueryParam(queryParam);
      if (!raw) return;

      const normalized = mapValue ? mapValue(raw) : raw;
      if (!normalized) return;

      this.attributes[queryParam] = normalized;
    });
  }

  getAll(): FunnelAttributes {
    return { ...this.attributes };
  }

  get(name: string): string | undefined {
    return this.attributes[name];
  }
}

export const funnelAttributesService = new FunnelAttributesService();
